/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/12/ticket': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<path pid="0" d="M10 6a2 2 0 012-2V2a1 1 0 00-1-1H1a1 1 0 00-1 1v2a2 2 0 010 4v2a1 1 0 001 1h10a1 1 0 001-1V8a2 2 0 01-2-2z" _fill="#272c33"/>'
  }
})
